// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput_container__1r7k7","button":"SearchInput_button__37SFA"};